<template>
  <a class="download-data" :class="color"  :href="publicPath+file" :type="type" :download="downloadname">
    <span class="download-title">{{ name }}<span class="a11y-solo-lectura">.</span></span>
    <span class="download-icon" aria-hidden="true">
      <span class="icono-md icono-atras" />
      <!--arrow-down v-if="!isA11yContrast" fillColor="#216C42" :size="36" />
      <arrow-down v-if="isA11yContrast" fillColor="#31130F" :size="36" /-->
    </span>
    <span class="a11y-solo-lectura">
      Link de descarga en formato: {{ format }}, Peso: {{weight}}.
      Contiene los datos en CSV y su correspondiente nota metodológica.
    </span>
  </a>
</template>

<script>
export default {
  name: 'DownloadData',
  components: {},
  props: {
    file: String,
    type: String,
    format: String,
    name: String,
    downloadname: String,
    weight: String,
    color: String
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    isA11yContrast() {
      return this.$store.getters.isA11yContrast
    }
  }
}
</script>

<style scoped lang="scss">
.download-data {
  display: flex;
  align-items: center;
  margin-top: $space *.5;
  margin-bottom: $space *.5;
  margin-left: - ($space * .5);
  margin-right: - ($space * .5);
  padding: 0 $space * .5;
  position: relative;
  transition: background-color .27s ease-in-out;
  .download-title {
    flex: 1 0;
    max-width: calc(100% - #{$space});
    padding-bottom: $space;
    font-weight: bolder;
    @media (min-width: $breakpoint-tablet) {
      font-size: 1.3rem;
    }
  }
  .download-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    height: $space * 1.75;
    width: $space * 1.75;
    margin: $space * .75 $space * .25;

    color: $accion;
    transform: rotate(-90deg);
    
    .material-design-icon {
      margin-top: $space*.15;
      transition: margin-top .27s ease-in-out;
    }
  }
  &.cultivo {
    background: $color_tarjeta_cultivos;
    color: #fff;
  }
  &.maquinaria {
    background: $color_tarjeta_maquinaria;
    color: #fff;
  }
  &.herbicidas {
    background: $color_tarjeta_herbicidas;
    color: #fff;
  }
  &::after {
    content: "CSV y Nota metodológica";
    position: absolute;
    font-size: .8rem;
    font-weight: 600;
    bottom: $space * .25;
    @media (min-width: $breakpoint-tablet) {
      bottom: $space * .5;
    }
  }
  &:hover, &:focus {
    background: $accion-hover;
    .download-icon {
      .material-design-icon {
        margin-top: $space*.75;
      }
    }
  }
  .a11y-solo-lectura {
    display: none;
  }
}
</style>
